<template>
  <v-menu 
    v-model="menu"
    :close-on-content-click="false"
    :nudge-width="200"
    offset-x
  >
    <template v-slot:activator="{ on }">
      <v-btn 
        icon 
        v-on="on"
      >
        <v-icon color="error">
          mdi-delete
        </v-icon>
      </v-btn>
    </template>
    
    <v-card>
      <v-card-text>
        Are you sure you want to delete <b>{{ setting.name }}</b> ?
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          class="px-10"       
          @click="menu = false"
        >
          No
        </v-btn>
        <v-btn
          :loading="progressing"
          color="hrissecondary"   
          class="white--text px-10"       
          @click="submitForm"
        >
          Yes
        </v-btn>
      </v-card-actions>
    </v-card> 
  </v-menu>
</template>

<script>
  export default {
    props: {
      setting: {
        type: Object,
        required: true,
      },
    },
    data () {
      return {
        menu: null,
        progressing: false,
      }
    },
    methods: {
      submitForm () {
        this.progressing = true

        this.$api.leaveEntitlementSettings().delete(this.setting.id)
          .then(res => {
            this.$emit('deleted')
            this.$snack({ message: 'Leave Entitlement Setting Deleted Succesfully' }) 
            
            this.progressing = false
            this.menu = false
          })
      },
    },
  }
</script>
